export default "__VITE_ASSET__eb5aae86__"